export default {"src":"/_next/static/media/dancing_workshop.2e860861.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};